import React from 'react';
import { FaUserFriends, FaUserPlus } from 'react-icons/fa';
import './UserTypeSelector.scss';

interface UserTypeSelectorProps {
  onSelectType: (type: 'anonymous' | 'registered') => void;
}

const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ onSelectType }) => {
  return (
    <div className="user-type-selection">
      <h5 className="section-title">Selecciona el tipo de cliente</h5>
      <div className="type-options">
        <div className="type-option" onClick={() => onSelectType('anonymous')}>
          <div className="option-icon">
            <FaUserFriends />
          </div>
          <div className="option-content">
            <h6>Cliente sin registrar</h6>
            <p>Código QR de uso general sin información adicional</p>
          </div>
          <div className="option-arrow">→</div>
        </div>
        
        <div className="type-option" onClick={() => onSelectType('registered')}>
          <div className="option-icon">
            <FaUserPlus />
          </div>
          <div className="option-content">
            <h6>Cliente registrado</h6>
            <p>Para clientes frecuentes con perfil en el sistema</p>
          </div>
          <div className="option-arrow">→</div>
        </div>
      </div>
    </div>
  );
};

export default UserTypeSelector;
